/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SchedulingPreferences/view.blocks to change it.
import Content from './Content/index'
import Empty from './Empty/index'
import Error from './Error/index'
import Loading from './Loading/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SchedulingPreferences({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/SchedulingPreferences"
  
}) {
  return (<React.Fragment
>
<No
  viewPath={`${viewPath}/No`}
/>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
<Error
  viewPath={`${viewPath}/Error`}
/>
<Empty
  viewPath={`${viewPath}/Empty`}
/>
<Content
  viewPath={`${viewPath}/Content`}
/>
{children}
</React.Fragment>)
}